<!--
 * @Author: xuesong
 * @Date: 2021-04-19 10:51:27
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-05-13 11:52:31
 * @Description: 会诊-病历卡片
-->
<template>
  <div class="custom-syeight">
    <div class="info-content">
      <div class="top">
        <span class="text-icon"></span>
        <span class="text-sign">{{ data.text }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    },
  },
};
</script>

<style scoped lang="less">
.custom-syeight {
  width: 350px;
  border-radius: 6px;
  background: linear-gradient(180deg, #fffbf0 0%, #ffffff 100%);
  box-shadow: 0px 4px 8px 0px rgba(204, 204, 204, 0.2);
  cursor: pointer;
  .info-content {
    padding: 15px 20px;
    font-size: 12px;
    font-weight: 500;
    display: flex;
    flex-direction: column;
    .top {
      display: flex;
      align-items: center;
      .text-icon {
        display: flex;
        width: 32px;
        height: 32px;
        background: url(../../static/IMInput/text_icon.png) no-repeat;
        background-size: contain;
        margin-right: 8px;
      }
      span {
        font-size: 12px;
        color: #333333;
        a {
          color: #1a7bfc;
          &:hover {
            text-decoration: none;
          }
        }
      }
    }
  }
}
</style>